// Types

export function isActionItem(item) {
  return !item.type || item.type === 'item';
}
//# sourceMappingURL=types.js.map